export default __webpack_public_path__ + "static/jitka-9c88a6ab2962417a651d1f09a3e59591.jpg";